import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Percentage({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M16.5303 4.53033C16.8232 4.23744 16.8232 3.76256 16.5303 3.46967C16.2374 3.17678 15.7626 3.17678 15.4697 3.46967L16.5303 4.53033ZM15.4697 3.46967L3.46967 15.4697L4.53033 16.5303L16.5303 4.53033L15.4697 3.46967ZM16.25 15C16.25 15.6904 15.6904 16.25 15 16.25V17.75C16.5188 17.75 17.75 16.5188 17.75 15H16.25ZM15 16.25C14.3096 16.25 13.75 15.6904 13.75 15H12.25C12.25 16.5188 13.4812 17.75 15 17.75V16.25ZM13.75 15C13.75 14.3096 14.3096 13.75 15 13.75V12.25C13.4812 12.25 12.25 13.4812 12.25 15H13.75ZM15 13.75C15.6904 13.75 16.25 14.3096 16.25 15H17.75C17.75 13.4812 16.5188 12.25 15 12.25V13.75ZM6.25 5C6.25 5.69036 5.69036 6.25 5 6.25V7.75C6.51878 7.75 7.75 6.51878 7.75 5H6.25ZM5 6.25C4.30964 6.25 3.75 5.69036 3.75 5H2.25C2.25 6.51878 3.48122 7.75 5 7.75V6.25ZM3.75 5C3.75 4.30964 4.30964 3.75 5 3.75V2.25C3.48122 2.25 2.25 3.48122 2.25 5H3.75ZM5 3.75C5.69036 3.75 6.25 4.30964 6.25 5H7.75C7.75 3.48122 6.51878 2.25 5 2.25V3.75Z" fill="currentColor" fillOpacity={0.7} /></Svg>;
}
export default Percentage;